import { Box } from "@mui/material";
import { CustomizedShimmer } from "../components/CommonComponents/Shimmer";

const renderProductsLoadingHelper = (loading) => {
    if (loading) {
      return (
        <Box className="shimmerBox">
          <CustomizedShimmer />
        </Box>
      );
    }
    return null;
};

export default renderProductsLoadingHelper;